const config = {
    apiUrl: 'https://api.platao.net',
    //apiUrl: 'http://127.0.0.1:3000',
    userId: '',
    questionId: '',
    file: null
};

export default config;
